import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from 'styled-components';
import { makeHelperLine, makeHelperText, makeErrorMessage } from '../field/mixins';
export var HelperLine = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function () {
  return makeHelperLine();
});
export var HelperText = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function () {
  return makeHelperText();
});
export var ErrorMessage = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (prop) {
  return makeErrorMessage(prop);
});